/** The influence map's metric: views or comments (ruling `...-81-2-13`).
 *  `core`'s `read_breakdown` offers only these two -- no collector writes a
 *  repost count in production -- so a third option never renders here. */

import type { ReactNode } from 'react';

import { SEGMENTED_ITEM_CLASSNAME, ToggleGroup, ToggleGroupItem } from '../../../ui/toggle-group';
import type { BreakdownMetric } from '../api/schemas';
import { ds } from '../shared/messages';

const METRICS: readonly BreakdownMetric[] = ['views', 'comments'];

export function SeriesToggle(props: {
  metric: BreakdownMetric;
  onMetricChange: (metric: BreakdownMetric) => void;
}): ReactNode {
  return (
    <ToggleGroup
      type="single"
      spacing={1}
      aria-label={ds('metric.label')}
      value={props.metric}
      // Radix reports an empty string when the selected item is pressed
      // again; a segmented selector always has one option chosen.
      onValueChange={(next) => {
        if (next !== '') props.onMetricChange(next as BreakdownMetric);
      }}
      className="bg-secondary rounded-pill p-1"
    >
      {METRICS.map((metric) => (
        <ToggleGroupItem key={metric} value={metric} className={SEGMENTED_ITEM_CLASSNAME}>
          {ds(`metric.${metric}`)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
